import React from 'react'

import Markdown from '../../atoms/Markdown'
import Col from '../../atoms/Col'
import Description from '../../atoms/LandingPage/Description'

import { HeroImage, Container } from './styled'

export default ({ copyTop, heroImage }) =>
  copyTop ? (
    <Container>
      {heroImage && heroImage.src ? <HeroImage fetchPriority='high' {...heroImage} /> : null}
      <Description as={Col}>
        <Markdown children={copyTop} />
      </Description>
    </Container>
  ) : null
